import moment from "moment";

export const isSurveyFinished = survey => {
  const surveyEndDate = moment(survey.end);
  const currentDate = moment.utc();

  return currentDate.isAfter(surveyEndDate);
};

export const isSurveyStarted = survey => {
  const surveyStartDate = moment(survey.start);
  const currentDate = moment.utc();

  return currentDate.isAfter(surveyStartDate);
};


// WEBPACK FOOTER //
// ./src/api/Surveys.js